var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"confirmation-container"},[_c('div',{staticClass:"container text-center"},[_c('img',{staticClass:"mb-3",attrs:{"src":require("@/assets/images/icon.svg"),"alt":"RegAlytics Logo","width":"40"}}),_c('h3',[_vm._v("Confirm Your Account!")]),_c('p',[_vm._v("Please check your email and confirm your account to continue.")])])])
}]

export { render, staticRenderFns }